import { DataBean } from "../DataBean";


export class DOCDocumentType extends DataBean {

    public async getDOCDocumentType(iddocdocumenttype: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCDocumentType_getDOCDocumentType_Number", [iddocdocumenttype]);
    }

    public async getDOCDocumentTypeCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCDocumentTypeCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCDocumentType(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCDocumentType_updateDOCDocumentType_com.advantage.forms.bean.DOCDocumentType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCDocumentType"
            }
        ]);
    }

}